// AI editor global functions (used by both Tiptap and legacy Medium Editor)
// Medium Editor imports removed - Tiptap is now the primary editor

// Loading indicator for AI text actions
window._showAiEditorLoading = function(action) {
  window._removeAiEditorLoading();
  var labels = { rewrite: 'Rewriting', expand: 'Expanding', simplify: 'Simplifying', summarize: 'Summarizing' };
  var bar = document.createElement('div');
  bar.id = 'ai-editor-action-bar';
  bar.className = 'ai-editor-action-bar fade-in';
  bar.innerHTML = '<span class="ai-action-bar-label"><span class="inline-block float-left chat-loader mr-2"></span>' + (labels[action] || 'Processing') + ' with AI...</span>';
  var editorContent = document.querySelector('.editor-content');
  if (editorContent) editorContent.insertBefore(bar, editorContent.firstChild);
};

window._removeAiEditorLoading = function() {
  var existing = document.getElementById('ai-editor-action-bar');
  if (existing) existing.remove();
  var editorField = document.querySelector('.editable');
  if (editorField) editorField.classList.remove('ai-editor-loading');
};

window._showAiEditorActionBar = function() {
  // Remove any existing top bar
  var existing = document.getElementById('ai-editor-action-bar');
  if (existing) existing.remove();

  // Store edit data keyed by stream ID so we can have multiple pending edits
  window._aiPendingEdits = window._aiPendingEdits || {};
  window._aiPendingEdits[window._aiStreamId] = {
    originalHTML: window._aiEditorOriginalHTML,
    markedHTML: window._aiEditorMarkedHTML,
    selectedText: window._aiEditorSelectedText,
    action: window._aiEditorPendingAction,
    markerString: window._aiMarkerString,
    editId: window._aiEditorEditId
  };

  // Store edit_id on the highlight span for cross-session reference
  var hl = document.getElementById(window._aiStreamId);
  if (hl && window._aiEditorEditId) {
    hl.setAttribute('data-edit-id', window._aiEditorEditId);
  }

  // Add controls OUTSIDE the editable area so Medium Editor can't strip them
  var highlight = document.getElementById(window._aiStreamId);
  if (!highlight) return;

  var controls = document.createElement('div');
  controls.className = 'ai-edit-inline-controls fade-in';
  controls.dataset.editId = window._aiStreamId;
  var actionLabels = { rewrite: 'Rewritten', expand: 'Expanded', simplify: 'Simplified', summarize: 'Summarized' };
  var actionLabel = actionLabels[window._aiEditorPendingAction] || 'AI Edit';
  controls.innerHTML =
    '<span class="ai-edit-inline-label"><span class="fas fa-wand-magic-sparkles mr-1"></span>' + actionLabel + '</span>' +
    '<div class="ai-edit-inline-buttons">' +
      '<button class="ai-edit-inline-btn ai-action-accept" title="Accept"><span class="fas fa-check"></span></button>' +
      '<button class="ai-edit-inline-btn ai-action-decline" title="Decline"><span class="fas fa-times"></span></button>' +
      '<button class="ai-edit-inline-btn ai-action-regenerate" title="Regenerate"><span class="fas fa-arrows-rotate"></span></button>' +
    '</div>';

  // Position next to the highlight, but in the editor-content container (outside .editable)
  var editorContent = document.querySelector('.editor-content');
  if (editorContent) {
    editorContent.appendChild(controls);
    window._positionAiControls(controls, highlight);
  }

  // Reposition on scroll and resize
  var scrollContainer = editorContent;
  var repositionHandler = function() {
    window._positionAiControls(controls, highlight);
  };
  scrollContainer.addEventListener('scroll', repositionHandler);
  window.addEventListener('resize', repositionHandler);
  controls._scrollHandler = repositionHandler;
  controls._scrollContainer = scrollContainer;

  controls.querySelectorAll('button').forEach(function(btn) {
    btn.addEventListener('mousedown', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var action = this.classList.contains('ai-action-accept') ? 'accept' :
                   this.classList.contains('ai-action-decline') ? 'decline' : 'regenerate';
      var editId = controls.dataset.editId;
      window._handleAiEditorAction(action, editId);
    });
  });
};

window._positionAiControls = function(controls, highlight) {
  if (!highlight || !controls || !controls.parentNode || !document.body.contains(highlight)) return;
  var highlightRect = highlight.getBoundingClientRect();
  if (highlightRect.width === 0 && highlightRect.height === 0) return;
  var containerRect = controls.parentNode.getBoundingClientRect();
  controls.style.top = (highlightRect.top - containerRect.top + controls.parentNode.scrollTop - 28) + 'px';
  controls.style.right = '8px';
};

window._handleAiEditorAction = function(action, editId) {
  var editorField = document.querySelector('.editable') || document.querySelector('.ProseMirror');
  var editor = window.tiptapEditor || (window.MediumEditor ? MediumEditor.getEditorFromElement(editorField) : null);
  var editData = (window._aiPendingEdits || {})[editId];

  var highlight = document.getElementById(editId);
  var controls = document.querySelector('.ai-edit-inline-controls[data-edit-id="' + editId + '"]');

  if (action === 'accept') {
    // Get DB edit ID BEFORE removing the highlight
    var dbEditId = editData && editData.editId;
    if (!dbEditId && highlight) {
      dbEditId = highlight.getAttribute('data-edit-id');
    }

    // Replace highlight span with its contents
    if (highlight) {
      highlight.outerHTML = highlight.innerHTML;
    } else {
      // Fallback: find by class + data attribute match
      editorField.querySelectorAll('.ai-editor-highlight').forEach(function(el) {
        if (el.id === editId || el.getAttribute('data-edit-id') === (dbEditId || '')) {
          el.outerHTML = el.innerHTML;
        }
      });
    }
    if (controls) {
      if (controls._scrollContainer && controls._scrollHandler) { controls._scrollContainer.removeEventListener('scroll', controls._scrollHandler); window.removeEventListener('resize', controls._scrollHandler); }
      controls.remove();
    }
    if (dbEditId) {
      var csrf = document.querySelector('meta[name="csrf-token"]');
      fetch('/posts/ai_edit_update?id=' + dbEditId + '&status=accepted', {
        method: 'PATCH',
        headers: { 'X-CSRF-Token': csrf ? csrf.getAttribute('content') : '' },
        credentials: 'same-origin'
      });
    }

    if (window._aiPendingEdits) delete window._aiPendingEdits[editId];
    // Force save clean content
    var textarea = document.getElementById('post_body');
    if (textarea && editorField) {
      textarea.value = editorField.innerHTML;
      // Immediate fetch save
      // Trigger autosave to persist
      document.dispatchEvent(new KeyboardEvent('keyup', { key: 'Enter' }));
    }

  } else if (action === 'decline') {
    // Get DB edit ID BEFORE modifying the DOM
    var dbDeclineId = editData && editData.editId;
    if (!dbDeclineId && highlight) {
      dbDeclineId = highlight.getAttribute('data-edit-id');
    }

    if (editData && editData.originalHTML) {
      // Full restore to original (same session)
      editorField.innerHTML = editData.originalHTML;
    } else {
      // Restore from stored original text (cross-session)
      if (highlight) {
        var origText = editData && editData.originalText ? editData.originalText : null;
        if (origText) {
          highlight.outerHTML = origText;
        } else {
          var p = highlight.parentNode;
          while (highlight.firstChild) p.insertBefore(highlight.firstChild, highlight);
          p.removeChild(highlight);
        }
      }
    }
    if (controls) {
      if (controls._scrollContainer && controls._scrollHandler) { controls._scrollContainer.removeEventListener('scroll', controls._scrollHandler); window.removeEventListener('resize', controls._scrollHandler); }
      controls.remove();
    }
    if (dbDeclineId) {
      var csrfD = document.querySelector('meta[name="csrf-token"]');
      fetch('/posts/ai_edit_update?id=' + dbDeclineId + '&status=declined', {
        method: 'PATCH',
        headers: { 'X-CSRF-Token': csrfD ? csrfD.getAttribute('content') : '' },
        credentials: 'same-origin'
      });
    }

    if (window._aiPendingEdits) delete window._aiPendingEdits[editId];
    // Sync textarea and trigger autosave
    var textareaD = document.getElementById('post_body');
    if (textareaD && editorField) {
      textareaD.value = editorField.innerHTML;
    }
    document.dispatchEvent(new KeyboardEvent('keyup', { key: 'Enter' }));

  } else if (action === 'regenerate') {
    if (!editData || !editData.selectedText) return;

    // Get DB edit ID BEFORE modifying the DOM
    var dbRegenId = editData && editData.editId;
    if (!dbRegenId && highlight) {
      dbRegenId = highlight.getAttribute('data-edit-id');
    }

    // Build marker and marked HTML from current state
    var marker = 'AI_SLOT_MARKER_' + Date.now();
    var newStreamId = 'ai-stream-' + Date.now();

    var originalHTML = editData.originalHTML || editorField.innerHTML;
    if (highlight) {
      highlight.outerHTML = marker;
    }
    var markedHTML = editorField.innerHTML;
    editorField.innerHTML = originalHTML;

    // Remove old controls
    if (controls) {
      if (controls._scrollContainer && controls._scrollHandler) { controls._scrollContainer.removeEventListener('scroll', controls._scrollHandler); window.removeEventListener('resize', controls._scrollHandler); }
      controls.remove();
    }

    // Lock editor
    editorField.setAttribute('contenteditable', 'false');
    editorField.classList.add('ai-editor-locked', 'ai-editor-loading');

    // Set up state for streaming
    window._aiStreamId = newStreamId;
    window._aiEditorOriginalHTML = originalHTML;
    window._aiEditorMarkedHTML = markedHTML;
    window._aiMarkerString = marker;
    window._aiEditorSelectedText = editData.selectedText;
    window._aiEditorPendingAction = editData.action;

    delete window._aiPendingEdits[editId];
    window._showAiEditorLoading(editData.action);

    var csrfToken = document.querySelector('meta[name="csrf-token"]');
    var token = csrfToken ? csrfToken.getAttribute('content') : '';

    if (dbRegenId) {
      fetch('/posts/ai_edit_update?id=' + dbRegenId + '&status=declined&regenerate=true', {
        method: 'PATCH',
        headers: { 'X-CSRF-Token': token },
        credentials: 'same-origin'
      });
    }

    fetch('/posts/ai_text_action', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': token },
      body: JSON.stringify({
        text: editData.selectedText.trim(),
        ai_action: editData.action,
        post_id: document.querySelector('.post-form-wrapper')?.getAttribute('data-post-id'),
        marker_id: newStreamId
      }),
      credentials: 'same-origin'
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status === 'success' && data.content) {
        if (data.edit_id) window._aiEditorEditId = data.edit_id;
        window._streamAiResponseIntoEditor(editorField, data.content);
      } else {
        editorField.innerHTML = originalHTML;
        editorField.setAttribute('contenteditable', 'true');
        editorField.classList.remove('ai-editor-locked', 'ai-editor-loading');
        window._removeAiEditorLoading();
      }
    })
    .catch(function() {
      editorField.innerHTML = originalHTML;
      editorField.setAttribute('contenteditable', 'true');
      editorField.classList.remove('ai-editor-locked', 'ai-editor-loading');
      window._removeAiEditorLoading();
    });
    return;
  }
};

// Sync medium-editor content to the hidden textarea and trigger a save
window._syncAndSaveEditor = function(editorField, editor) {
  // Trigger medium-editor's internal content tracking
  if (editor) {
    editor.trigger('editableInput', null, editor.elements[0]);
  }

  // Save innerHTML directly — display_body strips highlights for public views
  var textarea = document.getElementById('post_body');
  if (textarea && editorField) {
    textarea.value = editorField.innerHTML;
  }

  // Restart autosave (it listens for keyup/paste)
  document.dispatchEvent(new KeyboardEvent('keyup', { key: 'Enter' }));
  document.dispatchEvent(new Event('paste', { bubbles: true }));
};

// Save editor content before page unload to prevent data loss
window.addEventListener('beforeunload', function() {
  var editorField = document.querySelector('.editable');
  var textarea = document.getElementById('post_body');
  if (editorField && textarea) {
    // Save with highlights if pending edits exist (persists across sessions)
    textarea.value = editorField.innerHTML;
    // Use sendBeacon for reliable save on page exit
    var form = document.querySelector('#publishForm');
    if (form) {
      var formData = new FormData(form);
      navigator.sendBeacon(form.action, formData);
    }
  }
});

// Ensure highlights persist through autosave: re-sync textarea on every form submit
// (Medium Editor may overwrite textarea with its own serialization that strips data attributes)
document.addEventListener('submit', function(e) {
  var form = e.target;
  if (form && form.id === 'publishForm') {
    var editorField = document.querySelector('.editable');
    var textarea = document.getElementById('post_body');
    if (editorField && textarea) {
      textarea.value = editorField.innerHTML;
    }
  }
}, true); // capture phase — runs before Medium Editor's handler


// Stream AI response into editor with typing animation
// (Must be outside standardEditable so Tiptap can use it too)
window._streamAiResponseIntoEditor = function(editorField, responseHTML) {
    var marker = window._aiMarkerString;

    // Place the stream target div where the marker is
    editorField.innerHTML = window._aiEditorMarkedHTML.replace(
      marker,
      '<span id="' + window._aiStreamId + '" class="ai-editor-highlight"' +
        ' data-ai-action="' + window._aiEditorPendingAction + '"' +
        ' data-ai-text="' + encodeURIComponent(window._aiEditorSelectedText) + '"' +
        ' data-ai-original="' + encodeURIComponent(window._aiEditorSelectedText) + '"' +
      '></span>'
    );

    var target = document.getElementById(window._aiStreamId);
    if (!target) {
      editorField.innerHTML = window._aiEditorMarkedHTML.replace(marker, responseHTML);
      window._finishAiStream(editorField);
      return;
    }

    // Split into characters but keep HTML tags whole
    var tokens = responseHTML.match(/<[^>]+>|[^<]/g) || [];
    var currentIndex = 0;
    var batchSize = 5;
    var interval = 15;
    var accumulated = '';

    window._removeAiEditorLoading();

    function streamNext() {
      if (currentIndex >= tokens.length) {
        window._finishAiStream(editorField);
        return;
      }

      for (var i = 0; i < batchSize && currentIndex < tokens.length; i++, currentIndex++) {
        accumulated += tokens[currentIndex];
      }

      // Set full innerHTML each time so browser parses complete HTML
      // Append cursor inline at the end of the content
      target.innerHTML = accumulated + '<span class="streaming-cursor inline-cursor"></span>';

      var cursor = target.querySelector('.streaming-cursor');
      if (cursor) cursor.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

      requestAnimationFrame(function() {
        setTimeout(streamNext, interval);
      });
    }
    streamNext();
  };

  window._finishAiStream = function(editorField) {
    // Remove cursor
    var target = document.getElementById(window._aiStreamId);
    if (target) {
      var cursor = target.querySelector('.streaming-cursor');
      if (cursor) cursor.remove();
    }

    // Unlock editor
    editorField.setAttribute('contenteditable', 'true');
    editorField.classList.remove('ai-editor-locked');

    // If the highlight span is a direct child of the editor (not inside a <p>),
    // wrap it in a <p> to maintain proper formatting
    var highlight = editorField.querySelector('.ai-editor-highlight');
    if (highlight && highlight.parentNode === editorField) {
      var p = document.createElement('p');
      highlight.parentNode.insertBefore(p, highlight);
      p.appendChild(highlight);
    }

    // Place cursor after the highlight
    if (highlight) {
      var lastEl = highlight.lastElementChild || highlight;
      var range = document.createRange();
      range.selectNodeContents(lastEl);
      range.collapse(false);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      lastEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    // Save to textarea WITH highlights preserved
    var textarea = document.getElementById('post_body');
    if (textarea) {
      textarea.value = editorField.innerHTML;
    }

    // Pause autosave while edits are pending (it triggers Medium Editor serialization)


    // Show inline controls after a tick to avoid Medium Editor cleanup
    setTimeout(function() {
      window._showAiEditorActionBar();
    }, 50);

    // Clear global AI processing flag (used by Tiptap bubble menu)
    window._tiptapAiProcessing = false;

    // Rebuild Tiptap editor after AI flow (it was destroyed to allow DOM manipulation)
    var tiptapContainer = document.querySelector('[data-controller="tiptap-editor"]');
    if (tiptapContainer) {
      // Trigger a custom event that the Tiptap controller listens for
      tiptapContainer.dispatchEvent(new CustomEvent('tiptap:rebuild'));
    }
  };

